import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import VuetifyConfirm from "vuetify-confirm";

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: "EVET",
  buttonFalseText: "HAYIR",
  color: "primary",
  icon: false
});

export default VuetifyConfirm;
